import { Box, Tooltip } from "@mui/material";
import sdgBanner from "../../earthly-org/references/sdgs/sdg-banner.svg";
import type { SDGBlockProps } from "../../types";
import { SDGOptions } from "../../../../utils";

function SDGBlock({ sdgs = [] }: SDGBlockProps) {
  const selectedSdgs = new Set(sdgs);

  return (
    <Tooltip
      followCursor
      title={`This component shows the currently selected sdgs`}
    >
      <Box
        data-testid="sdg-block"
        sx={{
          width: "100%",
          minWidth: 0,
          maxWidth: "750px",
          backgroundColor: "common.white",
          p: { xs: 1.5, sm: 2.5 },
          border: "solid 3px",
          borderColor: "background.banner",
          placeSelf: "center",
        }}
      >
        <Box
          component="img"
          src={sdgBanner}
          alt="Sustainable Development Goals"
          data-testid="sdg-banner"
          sx={{
            display: "block",
            width: { xs: "48%", sm: "34%" },
            maxWidth: 260,
            mb: { xs: 1.5, sm: 2.5 },
          }}
        />

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(9, minmax(0, 1fr))",
            gap: { xs: 0.5, sm: 0.75 },
          }}
        >
          {SDGOptions.map(({ id, image }) => {
            const isSelected = selectedSdgs.has(id);

            return (
              <Box
                component="img"
                key={id}
                src={image}
                alt={`Sustainable Development Goal ${id}`}
                data-testid={`sdg-${id}`}
                data-selected={isSelected}
                sx={{
                  display: "block",
                  width: "100%",
                  aspectRatio: "1 / 1",
                  objectFit: "contain",
                  filter: isSelected ? "none" : "grayscale(1)",
                  opacity: isSelected ? 1 : 0.2,
                }}
              />
            );
          })}
        </Box>
      </Box>
    </Tooltip>
  );
}

export default SDGBlock;
